"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangeAttributeValues = useChangeAttributeValues;
const react_1 = require("react");
const product_values_1 = require("../../../../client/product-values");
const product_table_1 = require("../../../../common/product-table");
const attributes_1 = require("../../../../constants/attributes");
const hooks_1 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
function useChangeAttributeValues({ productId, label, onComplete, }) {
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { createProductValue } = (0, product_values_1.useCreateProductValue)();
    const { deleteProductValue } = (0, product_values_1.useDeleteProductValue)();
    const handleSelectionSave = (0, react_1.useCallback)((...args_1) => __awaiter(this, [...args_1], void 0, function* (newValues = [], prevValues = []) {
        // Not Applicable value was transformed into a shorter form for display in the table
        // TODO: add support for passing both label and value as the chip's value
        const specialAttributeValueLabel = t({ key: attributes_1.SpecialAttributeValueToLocalizationKey[attributes_1.SpecialAttributeValue.NotApplicable] });
        const { valuesToCreate, valuesToDelete } = (0, product_table_1.getAttributeValueChanges)(newValues, prevValues, specialAttributeValueLabel);
        if (!valuesToCreate.length && !valuesToDelete.length) {
            yield onComplete(false);
            return;
        }
        setLoading(true);
        const promises = [];
        if (valuesToCreate.length) {
            const values = valuesToCreate.map((value) => ({ name: value === specialAttributeValueLabel ? attributes_1.SpecialAttributeValue.NotApplicable : value, description: '' }));
            promises.push(createProductValue([{
                    name: label,
                    description: '',
                    values,
                }], [productId], label));
        }
        if (valuesToDelete.length) {
            const values = valuesToDelete.map((value) => (value === specialAttributeValueLabel ? attributes_1.SpecialAttributeValue.NotApplicable : value));
            promises.push(deleteProductValue(values, label, [productId]));
        }
        try {
            yield Promise.all(promises);
            yield onComplete(true);
        }
        catch (e) {
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
        setLoading(false);
    }), [
        createProductValue,
        label,
        productId,
        deleteProductValue,
        onComplete,
        addError,
        t,
    ]);
    return {
        handleSelectionSave,
        isLoading: loading,
    };
}
